import React, { useMemo } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGroupChatContext } from '../../context/groupchatContext';
import { FiAlignJustify } from "react-icons/fi";
import PreviewSelectField from '../../components/reactHookFormFields/previewSelectField';
import MainPageDialog from '../../components/dialog';
import LocationAppointment from '../appointment/locationAppointment';
import { useEffect } from 'react';
import { useGetNursingHomeLocationsQuery, useGetPracticeLocationsQuery } from '../../services/chatService';
import { mdScreenWidth } from '../../helpers/utility';
import { AdvanceSelect } from '../../components/reactHookFormFields/advanceSelectField';
import { CheckBox } from '../../components/reactHookFormFields/checkbox';
import LocationCheckin from '../locationCheckin';
import BroadcastMessage from '../locationCheckin/broadcastMessage';
import { ChevronDownIcon, FunnelIcon, MapPinIcon } from '@heroicons/react/20/solid';
import { getVisibleSettingsTabs, settings_sidebar_tabs } from '../settings/SettingsPage/settings_constants';

const HeaderChat = React.memo(() => {

    const groupChatContext = useGroupChatContext();

    const { authData, isOpeningSideBar, setIsOpeningSideBar, screenWidth, setSelectedLocations, chatFilter, setChatFilter,
        logoutApp, loadThreadChats, setShowSettings, selectedChatTab, setShowGlobalDocuments, userAcl  } = useMemo(() => ({
        authData: groupChatContext.authData,
        isOpeningSideBar: groupChatContext.isOpeningSideBar,
        setIsOpeningSideBar: groupChatContext.setIsOpeningSideBar,
        screenWidth: groupChatContext.screenWidth,
        setSelectedLocations: groupChatContext.setSelectedLocations,
        chatFilter: groupChatContext.chatFilter,
        setChatFilter: groupChatContext.setChatFilter,
        logoutApp: groupChatContext.logoutApp,
        loadThreadChats: groupChatContext.loadThreadChats,
        setShowSettings: groupChatContext.setShowSettings,
        selectedChatTab: groupChatContext.selectedChatTab,
        setShowGlobalDocuments: groupChatContext.setShowGlobalDocuments,
        userAcl: groupChatContext.userAcl
    }));

    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [isShowSearch, setIsShowSearch] = useState(false);
    const [isOpenApptPopup, setIsOpenApptPopup] = useState(false);
    const [isOpenCheckInPopup, setIsOpenCheckInPopup] = useState(false);
    const [isOpenBroadcastPopup, setIsOpenBroadcastPopup] = useState(false);
    const [practiceLocations, setPracticeLocations] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenLocationModal, setIsOpenLocationModal] = useState(false);

    const {
        control,
        getValues,
        setValue
     } = useForm({
        defaultValues: {},
    });

    const { data: providerLocations } = useGetPracticeLocationsQuery({ only_my_locations: 1 }, { skip: !authData?.is_provider });
    const { data: nursingHomeLocations }  = useGetNursingHomeLocationsQuery({ skip: authData?.is_provider });

    useEffect(() => {
        if (authData?.is_provider) {
            setPracticeLocations(providerLocations);
        } else {
            setPracticeLocations(nursingHomeLocations);
        }
    }, [providerLocations, nursingHomeLocations])
    
    useEffect(() => {
        setValue('practice_location', chatFilter.selected_location);
        onChangePracticeLocation(chatFilter.selected_location);
    }, []);


    const onChangePracticeLocation = (val) => {
        if(val){
            let selectedOpt = val;
            setValue('practice_location', selectedOpt);

            let selectedOptStr = '';
            if(selectedOpt?.length){
                selectedOptStr = selectedOpt.map((item)=>item.id).join(',');
            }
            setSelectedLocations(selectedOptStr);
        }
    }

    const onChangeFilterCheck = (event, name) => {
        if (event) {
            setChatFilter(prev => {
                const newFilter = { ...prev, [name]: !prev[name] };
                localStorage.setItem("chatFilter", JSON.stringify(newFilter));
                return newFilter;
            });
        }
    }
    const onSelectPatient = (val) => {

        if(!val) return;
        const fullNameParts = (val.full_name || val.name || '').trim().split(/\s+/).filter(Boolean);
        const fname = val.fname || fullNameParts[0] || '';
        const lname = val.lname || fullNameParts.slice(1).join(' ') || '';
        loadThreadChats({pid: val.pid, location: val.location,
            patient: {
                fname: fname, lname: lname, sex: val.sex, DOB: val.DOB, age: val.age, admission_location_type: val.admission_location_type,
                admission_type: val.admission_type, is_aco_patient: val.is_aco_patient, is_hospice: val.is_hospice, mrn: val.mrn,
                is_homehealth: val.is_homehealth, ccm_status: val.ccm_status, rpm_status: val.rpm_status, patient_group_color: val.patient_group_color
            }
        });
        setIsShowSearch(false)
    }

    useEffect(() => {
        if(screenWidth > mdScreenWidth){
            setIsShowSearch(false)
        }
    }, [screenWidth])

    const canShowSettings = useMemo(
        () => getVisibleSettingsTabs(settings_sidebar_tabs, { authData, userAcl }).length > 0,
        [authData, userAcl]
    );

    const menuItems = useMemo(
        () => [
          {
            label: "Settings",
            onClick: () => setShowSettings(true),
            show: canShowSettings,
          },
          {
            label: "Logout",
            onClick: logoutApp,
            show: true,
          },
        ],
        [canShowSettings, setShowSettings, logoutApp]
      );

    return (
        <header className={`${authData?.is_provider ? 'bg-ethizo_primary' : 'bg-bg-primary'} px-4 py-4 gap-1 text-white flex justify-between md:items-center`}>
            <div className={`flex gap-4  items-center flex-1`}>

                <button type="button" className="-m-2.5 p-2.5 inline-flex lg:hidden text-white" onClick={()=>setIsOpeningSideBar(!isOpeningSideBar)}>
                    <FiAlignJustify size={30} />
                </button>

                <div className='flex md:hidden'>
                    {!isShowSearch ? 
                        <button onClick={()=>setIsShowSearch(true)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        </button>
                    : null}
                </div>
                {isShowSearch ? null :
                    <>
                        {screenWidth < mdScreenWidth ? (
                            <>
                                <button
                                    type="button"
                                    onClick={() => setIsOpenLocationModal(true)}
                                    className="relative inline-flex items-center justify-center p-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none"
                                    title="Locations"
                                >
                                    <MapPinIcon className="w-4 h-4 text-gray-500" />
                                    {chatFilter?.selected_location?.length > 0 && (
                                        <span className="absolute -top-1 -right-1 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-teal-500 px-1 text-[10px] font-medium text-white">
                                            {chatFilter.selected_location.length > 99 ? '99+' : chatFilter.selected_location.length}
                                        </span>
                                    )}
                                </button>
                                {isOpenLocationModal && (
                                    <MainPageDialog
                                        title="Select Locations"
                                        onCancelHandler={() => setIsOpenLocationModal(false)}
                                        footerList={[{ title: 'Done', action: () => setIsOpenLocationModal(false), type: 'save' }]}
                                        contentScroll={false}
                                        hideOverFlow={true}
                                        contentCls="p-4 overflow-visible"
                                    >
                                        <div className="text-black w-full min-h-[320px] overflow-visible">
                                            <AdvanceSelect
                                                title="Locations"
                                                defaultValue={chatFilter?.selected_location}
                                                onChangeHandler={(data) => {
                                                    onChangePracticeLocation(data);
                                                    localStorage.setItem("chatFilter", JSON.stringify({ ...chatFilter, selected_location: data }));
                                                    setChatFilter(prev => ({ ...prev, selected_location: data }));
                                                }}
                                                control={control}
                                                setValue={setValue}
                                                name="practice_location"
                                                optionData={practiceLocations}
                                                showLabel="name"
                                            />
                                        </div>
                                    </MainPageDialog>
                                )}
                            </>
                        ) : (
                            <div className="text-black w-[140px] md:w-[228px] ">
                                <AdvanceSelect
                                    title="Locations"
                                    onChangeHandler={(data) => {
                                        onChangePracticeLocation(data);
                                        localStorage.setItem("chatFilter", JSON.stringify({ ...chatFilter, selected_location: data }));
                                        setChatFilter(prev => ({ ...prev, selected_location: data }));
                                    }}
                                    control={control}
                                    setValue={setValue}
                                    name="practice_location"
                                    optionData={practiceLocations}
                                    showLabel="name"
                                />
                            </div>
                        )}

                        <div className="relative inline-block text-left">
                            {(() => {
                                const activeFilterCount = [
                                    chatFilter.unread_only,
                                    chatFilter.urgent_only,
                                    chatFilter.unacknowledged,
                                    chatFilter.mention,
                                    chatFilter.attachment,
                                ].filter(Boolean).length;
                                return screenWidth < mdScreenWidth ? (
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(!isOpen)}
                                        className="relative inline-flex items-center justify-center p-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none"
                                        title={chatFilter.unread_only ? 'Unread Only' : chatFilter.urgent_only ? 'All Urgent' : chatFilter.unacknowledged ? 'Unacknowledged Urgent' : chatFilter.mention ? 'Mentions' : chatFilter.attachment ? 'Attachments' : 'Filter Messages'}
                                    >
                                        <FunnelIcon className="w-4 h-4 text-gray-500" />
                                        {activeFilterCount > 0 && (
                                            <span className="absolute -top-1 -right-1 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-teal-500 px-1 text-[10px] font-medium text-white">
                                                {activeFilterCount > 99 ? '99+' : activeFilterCount}
                                            </span>
                                        )}
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(!isOpen)}
                                        className="inline-flex items-center justify-between gap-2 px-4 py-2 border border-gray-300 bg-white text-gray-700 text-sm rounded-md shadow-sm hover:bg-gray-50 focus:outline-none"
                                    >
                                        <span>
                                            {chatFilter.unread_only
                                            ? 'Unread Only'
                                            : chatFilter.urgent_only
                                            ? 'All Urgent'
                                            : chatFilter.unacknowledged
                                            ? 'Unacknowledged Urgent'
                                            : chatFilter.mention
                                            ? 'Mentions'
                                            : chatFilter.attachment
                                            ? 'Attachments'
                                            : 'Filter Messages'}
                                        </span>
                                        <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                                    </button>
                                );
                            })()}
                            {isOpen && (
                                <div className="absolute z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                                    onMouseLeave={() => setIsOpen(false)}
                                >
                                    <div className="p-4 space-y-2">
                                        <CheckBox
                                        title="Unread Only"
                                        name="unread_only"
                                        control={control}
                                        labelClass="text-black"
                                        onChange={(event) => onChangeFilterCheck(event, 'unread_only')}
                                        defaultValue={chatFilter.unread_only}
                                        />
                                        <CheckBox
                                        title="All Urgent"
                                        name="urgent_only"
                                        control={control}
                                        labelClass="text-black"
                                        onChange={(event) => onChangeFilterCheck(event, 'urgent_only')}
                                        defaultValue={chatFilter.urgent_only}
                                        />
                                        <CheckBox
                                        title="Unacknowledged Urgent"
                                        name="unacknowledged"
                                        control={control}
                                        labelClass="text-black"
                                        onChange={(event) => onChangeFilterCheck(event, 'unacknowledged')}
                                        defaultValue={chatFilter.unacknowledged}
                                        />
                                        <CheckBox
                                        title="Tagged messages"
                                        name="mention"
                                        control={control}
                                        labelClass="text-black"
                                        onChange={(event) => onChangeFilterCheck(event, 'mention')}
                                        defaultValue={chatFilter.mention}
                                        />
                                        <CheckBox
                                        title="Attachments"
                                        name="attachment"
                                        control={control}
                                        labelClass="text-black"
                                        onChange={(event) => onChangeFilterCheck(event, 'attachment')}
                                        defaultValue={chatFilter.attachment}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                }
                {selectedChatTab == 'patient_chats' ?
                    <>
                        {isShowSearch ? 
                            <div className='md:hidden w-full flex gap-2 relative'>
                                <div className='w-full'>
                                    <PreviewSelectField onSendMessage={onSelectPatient} />
                                </div>
                                <button
                                    className="text-red-500 font-bold w-[20px] absolute right-1 z-10 top-4"
                                    onClick={()=>setIsShowSearch(false)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                                        <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                            :
                            <div className="w-3/12 hidden md:inline-block">
                                <PreviewSelectField onSendMessage={onSelectPatient} />
                            </div>
                        }
                    </>
                    :
                    null
                }
                {isShowSearch ? null :
                    <>
                        {/* <h1 className='text-xl font-bold text-nowrap pe-4'>
                            {authData.location_name}
                        </h1> */}
                        <div className='flex flex-col md:flex-row gap-0 md:gap-4 ml-auto md:pr-3'>
                            {selectedChatTab == 'location_chats' ?
                                <button className="text-white p-0 hover:text-blue-200 text-sm font-semibold" onClick={setIsOpenBroadcastPopup}>Broadcast Message</button>
                            : null}

                            {authData?.is_provider ? 
                                <button className="text-white p-0 hover:text-blue-200 text-sm font-semibold" onClick={setIsOpenCheckInPopup}>New Check In</button>
                                :
                                null
                            }

                            {authData?.is_provider ? 
                                <button className="text-white p-0 hover:text-blue-200 text-sm font-semibold" onClick={() => setShowGlobalDocuments(true)}>Documents</button>
                                :
                                null
                            }

                            <button className="text-white p-0 hover:text-blue-200 text-sm font-semibold" onClick={setIsOpenApptPopup}>Scheduler</button>

                        </div>
                    </>
                }
            </div>
           

                
            <div className="flex gap-4 items-center justify-end">

                <div className="relative inline-block text-left text-nowrap">
                    <button type="button" className="inline-flex bg-transparent w-full justify-center items-center gap-x-1.5 rounded-md text-sm font-semibold text-white" id="menu-button" aria-expanded="true" aria-haspopup="true" onClick={()=>setIsOpenMenu(!isOpenMenu)}>
                        <span className='hidden md:flex'>
                            {authData.name}
                        </span>
                        <svg className="-mr-1 h-5 w-5 text-white mt-1 md:mt-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                        </svg>
                    </button>
                    {isOpenMenu ? (
                        <div
                            onMouseLeave={() => setIsOpenMenu(false)}
                            className="absolute right-0 z-10 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="menu-button"
                            tabIndex="-1"
                        >
                            {menuItems
                            .filter(item => item.show)
                            .map((item, index) => (
                                <button
                                key={index}
                                type="button"
                                className="text-gray-700 block w-full px-4 py-2 text-left text-sm cursor-pointer hover:bg-gray-100 rounded-md"
                                onClick={item.onClick}
                                >
                                {item.label}
                                </button>
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
            {isOpenApptPopup ?
                <MainPageDialog
                    title='Appointments'
                    onCancelHandler={() => setIsOpenApptPopup(false)}
                    // modalSize="md"
                    maxHeight={true}
                    // customHeight={"min-h-[80vh] overflow-y-auto"}
                    component={
                        <LocationAppointment
                            closeLocationApptPopup={() => setIsOpenApptPopup(false)}
                            isOpenApptPopup={isOpenApptPopup}
                        />
                    }
                    footer={false}
                >
                </MainPageDialog>
                : null
            }

            {isOpenCheckInPopup ?
                <MainPageDialog
                    title='New Check In or Check Out'
                    onCancelHandler={() => setIsOpenCheckInPopup(false)}
                    // modalSize="md"
                    component={
                        <LocationCheckin
                            closeLocationApptPopup={() => setIsOpenCheckInPopup(false)}
                        />
                    }
                    footer={false}
                >
                </MainPageDialog>
                : null
            }

            {isOpenBroadcastPopup ?
                <MainPageDialog
                    title='Broadcast Message'
                    modalSize="md"
                    onCancelHandler={() => setIsOpenBroadcastPopup(false)}
                    component={
                        <BroadcastMessage onCancelHandler={() => setIsOpenBroadcastPopup(false)} />
                    }
                />
                : null
            }
        </header>
    );
});

export default HeaderChat;